import { render, staticRenderFns } from "./JsonViewer.vue?vue&type=template&id=042d0e00&scoped=true"
import script from "./JsonViewer.vue?vue&type=script&lang=js"
export * from "./JsonViewer.vue?vue&type=script&lang=js"
import style0 from "./JsonViewer.vue?vue&type=style&index=0&id=042d0e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d0e00",
  null
  
)

export default component.exports